module.exports = __webpack_public_path__ + "img/ic-chevron-left.4337e3ba.svg";